import { render, staticRenderFns } from "./Grupo_nomina.vue?vue&type=template&id=9a6603b8"
import script from "./Grupo_nomina.vue?vue&type=script&lang=js"
export * from "./Grupo_nomina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports